import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { SummaryDto } from '../../app/models/summary/summaryDto';

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
        fontSize: 9
    },
    PcsYear: {
        width: '50%',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    Internal: {
        paddingLeft: '2px',
        width: '45%',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    AccreditedCeActivity: {
        paddingLeft: '2px',
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    PersonalLearning: {
        paddingLeft: '2px',
        width: '45%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    ResearchOrTraining: {
        paddingLeft: '2px',
        width: '45%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    Total: {
        width: '40%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    ClinicalAudit: {
        width: '50%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    CreditsOnTarget: {
        width: '30%',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    VerificationStatus: {
        width: '40%',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingLeft: '7px'
    },
    item: {
        width: '50%',
        paddingTop: '5px',
        height: '20',
        textAlign: 'center'
    }
});

interface Props {
    legacySummaryData: SummaryDto[][] | null;
}

const LegacyReceiptTableRow = ({ legacySummaryData }: Props) => {
    return (
        <>
            {legacySummaryData?.map((item: SummaryDto[], index) => (
                <View style={styles.row} key={index}>
                    <Text style={styles.PcsYear}>
                        {item[0].text}
                        {item[1].text.toLowerCase() === "true" ? "*" : ""}
                    </Text>

                    <Text style={styles.Internal}>
                        {item[2].text}
                    </Text>

                    <Text style={styles.AccreditedCeActivity}>
                        {item[3].text}
                    </Text>

                    <Text style={styles.PersonalLearning}>
                        {item[4].text}
                    </Text>

                    <Text style={styles.ResearchOrTraining}>
                        {item[5].text}
                    </Text>

                    <Text style={styles.Total}>
                        {item[6].text}
                    </Text>

                    <Text style={styles.ClinicalAudit}>
                        {item[7].text}
                    </Text>

                    <Text style={styles.CreditsOnTarget}>
                        {item[8].text}
                    </Text>
                </View >
            ))}
        </>
    )
};

export default LegacyReceiptTableRow;